import { FlatBorderCard } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemLayoutStyled = styled(FlatBorderCard)`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.space.small};
  width: 100%;
  padding: ${(props) => props.theme.space.small};
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.colors.neutral};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`
